import React, { useMemo, useState } from 'react'
import 'bootstrap-icons/font/bootstrap-icons.css'
import './DashboardEventosCalendario.css'

const WEEKDAY_LABELS = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb']
const MONTH_NAMES = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro']

function formatHora(iso) {
  return new Date(iso).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })
}

function formatData(iso) {
  return new Date(iso).toLocaleDateString('pt-BR')
}

function chaveDia(d) {
  return new Date(d).toLocaleDateString('pt-BR')
}

export function classificarEventoDash(ev) {
  const nome = String(ev.nome_evento || '')
  const obs = String(ev.observacao || '')
  const tipo = ev.tipo_evento || 'vendas'
  const osMatch = nome.match(/OS\s*#?\s*(\d+)/i)
  const osNumero = osMatch ? `OS #${osMatch[1]}` : null
  const titulo = osNumero
    ? nome.replace(/OS\s*#?\s*\d+\s*[-–:]?\s*/i, '').trim() || nome
    : nome

  if (/vistoria/i.test(nome) || /vistoria/i.test(obs)) {
    return { categoria: 'Vistoria', variante: 'vistoria', osNumero, titulo }
  }
  if (tipo === 'operacional' || osNumero) {
    return { categoria: 'Instalação', variante: 'instalacao', osNumero, titulo }
  }
  return { categoria: 'Atendimento', variante: 'atendimento', osNumero, titulo }
}

function nomesAssociados(ev) {
  return (ev.eventos_calendario_usuarios || [])
    .map((x) => x.usuarios_sistema?.nome)
    .filter(Boolean)
}

const DashboardEventosCalendario = ({
  eventos = [],
  loading = false,
  filtro = 'dia',
  onFiltroChange,
  onAbrirCalendario
}) => {
  const [eventoDetalhe, setEventoDetalhe] = useState(null)
  const [diaMesSelecionado, setDiaMesSelecionado] = useState(null)

  const hoje = useMemo(() => new Date(), [])
  const classif = (ev) => classificarEventoDash(ev)

  const eventosPorDia = useMemo(() => {
    const map = {}
    eventos.forEach((ev) => {
      const key = chaveDia(ev.data_hora)
      if (!map[key]) map[key] = []
      map[key].push(ev)
    })
    Object.keys(map).forEach((k) => map[k].sort((a, b) => new Date(a.data_hora) - new Date(b.data_hora)))
    return map
  }, [eventos])

  const diasSemana = useMemo(() => {
    const d = new Date()
    const day = d.getDay()
    const off = day === 0 ? 6 : day - 1
    const start = new Date(d)
    start.setDate(d.getDate() - off)
    start.setHours(0, 0, 0, 0)
    return Array.from({ length: 7 }, (_, i) => {
      const x = new Date(start)
      x.setDate(start.getDate() + i)
      return x
    })
  }, [])

  const horasSemana = useMemo(() => {
    const set = new Set(eventos.map((ev) => formatHora(ev.data_hora)))
    return Array.from(set).sort()
  }, [eventos])

  const celulasMes = useMemo(() => {
    const first = new Date(hoje.getFullYear(), hoje.getMonth(), 1)
    const last = new Date(hoje.getFullYear(), hoje.getMonth() + 1, 0)
    const cells = []
    for (let i = 0; i < first.getDay(); i++) cells.push({ empty: true })
    for (let d = 1; d <= last.getDate(); d++) {
      const date = new Date(hoje.getFullYear(), hoje.getMonth(), d)
      const key = chaveDia(date)
      cells.push({
        empty: false,
        date,
        key,
        list: eventosPorDia[key] || [],
        isToday: date.toDateString() === hoje.toDateString()
      })
    }
    return cells
  }, [hoje, eventosPorDia])

  const eventosDiaMes = diaMesSelecionado ? (eventosPorDia[chaveDia(diaMesSelecionado)] || []) : []

  const badgeFiltro = () => {
    if (filtro === 'dia') {
      return `Hoje - ${hoje.toLocaleDateString('pt-BR')}`
    }
    if (filtro === 'semana') {
      const a = diasSemana[0]
      const b = diasSemana[6]
      return `${a.toLocaleDateString('pt-BR')} – ${b.toLocaleDateString('pt-BR')}`
    }
    return `${MONTH_NAMES[hoje.getMonth()]} ${hoje.getFullYear()}`
  }

  const renderEventoCard = (ev) => {
    const info = classif(ev)
    const hora = formatHora(ev.data_hora)
    return (
      <div key={ev.id} className={`dash-cal-event border-${info.variante}`}>
        <div className="dash-cal-event-row">
          <div className="dash-cal-event-hora">
            <i className="bi bi-clock me-1" aria-hidden="true" />
            {hora}
          </div>
          <div className="dash-cal-event-body">
            <div className="dash-cal-event-tags">
              <span className={`dash-cal-badge dash-cal-badge-${info.variante}`}>{info.categoria}</span>
              {info.osNumero && <span className="dash-cal-os">{info.osNumero}</span>}
            </div>
            <h6 className="dash-cal-event-title">{info.titulo}</h6>
            {ev.responsavel?.nome && (
              <small className="dash-cal-event-resp">
                <i className="bi bi-person me-1" aria-hidden="true" />
                {ev.responsavel.nome}
              </small>
            )}
          </div>
          <div className="dash-cal-event-action">
            <button
              type="button"
              className={`dash-cal-btn-detalhes dash-cal-btn-${info.variante}`}
              onClick={() => setEventoDetalhe(ev)}
            >
              <i className="bi bi-eye me-1" aria-hidden="true" />
              Ver Detalhes
            </button>
          </div>
        </div>
      </div>
    )
  }

  const detalhe = eventoDetalhe ? classif(eventoDetalhe) : null
  const associados = eventoDetalhe ? nomesAssociados(eventoDetalhe) : []

  return (
    <div className="dash-cal-card">
      <div className="dash-cal-header">
        <div className="dash-cal-header-title">
          <i className="bi bi-calendar3" aria-hidden="true" />
          <h5>Eventos do Calendário</h5>
        </div>
        <div className="dash-cal-toggle" role="group" aria-label="Visualização">
          {['dia', 'semana', 'mes'].map((v) => (
            <button
              key={v}
              type="button"
              className={filtro === v ? 'is-active' : ''}
              onClick={() => {
                onFiltroChange(v)
                setDiaMesSelecionado(null)
              }}
            >
              {v === 'dia' ? 'Dia' : v === 'semana' ? 'Semana' : 'Mês'}
            </button>
          ))}
        </div>
      </div>

      <div className="dash-cal-body">
        {loading ? (
          <div className="text-center py-4">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Carregando...</span>
            </div>
          </div>
        ) : (
          <>
            <div className="dash-cal-meta">
              <span className="dash-cal-period">
                <i className="bi bi-calendar-date me-2" aria-hidden="true" />
                {badgeFiltro()}
              </span>
              <small>{eventos.length} compromisso{eventos.length === 1 ? '' : 's'} agendado{eventos.length === 1 ? '' : 's'}</small>
            </div>

            {filtro === 'dia' && (
              eventos.length === 0
                ? <p className="dash-cal-empty">Nenhum evento no período selecionado.</p>
                : <div className="dash-cal-lista">{eventos.map(renderEventoCard)}</div>
            )}

            {filtro === 'semana' && (
              horasSemana.length === 0 ? (
                <p className="dash-cal-empty">Nenhum evento no período selecionado.</p>
              ) : (
                <div className="dash-cal-semana-wrap">
                  <table className="dash-cal-semana">
                    <thead>
                      <tr>
                        <th>Horário</th>
                        {diasSemana.map((d) => (
                          <th key={d.toISOString()} className={d.toDateString() === hoje.toDateString() ? 'is-today' : ''}>
                            {WEEKDAY_LABELS[d.getDay()]} ({String(d.getDate()).padStart(2, '0')}/{String(d.getMonth() + 1).padStart(2, '0')})
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {horasSemana.map((hora) => (
                        <tr key={hora}>
                          <td className="dash-cal-semana-hora">{hora}</td>
                          {diasSemana.map((d) => {
                            const list = (eventosPorDia[chaveDia(d)] || []).filter((ev) => formatHora(ev.data_hora) === hora)
                            const isToday = d.toDateString() === hoje.toDateString()
                            return (
                              <td key={d.toISOString() + hora} className={isToday ? 'is-today' : ''}>
                                {list.length === 0 ? <span className="text-muted">—</span> : list.map((ev) => {
                                  const info = classif(ev)
                                  return (
                                    <button
                                      key={ev.id}
                                      type="button"
                                      className={`dash-cal-semana-chip dash-cal-badge-${info.variante}`}
                                      title={ev.nome_evento}
                                      onClick={() => setEventoDetalhe(ev)}
                                    >
                                      {info.osNumero || info.titulo}
                                    </button>
                                  )
                                })}
                              </td>
                            )
                          })}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )
            )}

            {filtro === 'mes' && (
              <div className="dash-cal-mes">
                <h6 className="dash-cal-mes-title">{MONTH_NAMES[hoje.getMonth()]} {hoje.getFullYear()}</h6>
                <div className="dash-cal-mes-weekdays">
                  {WEEKDAY_LABELS.map((l) => <div key={l}>{l}</div>)}
                </div>
                <div className="dash-cal-mes-grid">
                  {celulasMes.map((c, i) => (
                    <button
                      key={i}
                      type="button"
                      disabled={c.empty}
                      className={`dash-cal-mes-cell${c.empty ? ' is-empty' : ''}${c.isToday ? ' is-today' : ''}${c.list?.length ? ' has-events' : ''}${!c.empty && diaMesSelecionado && chaveDia(diaMesSelecionado) === c.key ? ' is-selected' : ''}`}
                      onClick={() => !c.empty && setDiaMesSelecionado(c.date)}
                    >
                      {!c.empty && (
                        <>
                          <span>{c.date.getDate()}</span>
                          {c.list.length > 0 && <i className="dash-cal-mes-dot" />}
                        </>
                      )}
                    </button>
                  ))}
                </div>
                {diaMesSelecionado && (
                  <div className="dash-cal-mes-dia mt-3">
                    <p className="dash-cal-mes-dia-label">
                      {diaMesSelecionado.toLocaleDateString('pt-BR', { weekday: 'long', day: 'numeric', month: 'long' })}
                    </p>
                    {eventosDiaMes.length === 0
                      ? <p className="dash-cal-empty mb-0">Nenhum evento neste dia.</p>
                      : <div className="dash-cal-lista">{eventosDiaMes.map(renderEventoCard)}</div>}
                  </div>
                )}
              </div>
            )}
          </>
        )}
      </div>

      {eventoDetalhe && detalhe && (
        <div className="dash-cal-modal-overlay" onClick={() => setEventoDetalhe(null)}>
          <div className="dash-cal-modal" onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true">
            <div className="dash-cal-modal-header">
              <div>
                <span className="dash-cal-modal-hora">{formatHora(eventoDetalhe.data_hora)}</span>
                <h5>{eventoDetalhe.nome_evento}</h5>
                <span className="dash-cal-modal-cat">({detalhe.categoria})</span>
              </div>
              <div className="dash-cal-modal-actions">
                <button type="button" className="dash-cal-modal-edit" onClick={onAbrirCalendario}>
                  EDITAR
                </button>
              </div>
            </div>
            <div className="dash-cal-modal-body">
              <div>
                <span className="dash-cal-modal-label">Tipo:</span>
                <span>{(eventoDetalhe.tipo_evento || 'vendas') === 'operacional' ? 'Operacional' : 'Vendas'}</span>
              </div>
              <div>
                <span className="dash-cal-modal-label">Cadastrado por:</span>
                <span>{eventoDetalhe.responsavel?.nome || '—'}</span>
              </div>
              <div>
                <span className="dash-cal-modal-label">Associados:</span>
                <span>{associados.length ? associados.join(', ') : 'Nenhum'}</span>
              </div>
              {eventoDetalhe.observacao && (
                <div className="dash-cal-modal-obs">
                  <span className="dash-cal-modal-label">Observação:</span>
                  <em>{eventoDetalhe.observacao}</em>
                </div>
              )}
              <div className="dash-cal-modal-status">
                <span>{eventoDetalhe.executado ? '✅' : '⏳'}</span>
                <strong>{eventoDetalhe.executado ? 'Realizado' : 'Não realizado'}</strong>
                <small className="text-muted ms-2">{formatData(eventoDetalhe.data_hora)}</small>
              </div>
            </div>
            <div className="dash-cal-modal-footer">
              <button type="button" className="btn btn-secondary btn-sm" onClick={() => setEventoDetalhe(null)}>
                Fechar
              </button>
              <button type="button" className="btn btn-primary btn-sm" onClick={onAbrirCalendario}>
                Abrir calendário
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default DashboardEventosCalendario
